//#region Imports
import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  StyleSheet,
  Platform,
  SafeAreaView,
  ActivityIndicator,
  View,
  useWindowDimensions,
  ScrollView,
  Linking
} from "react-native";
import { useTheme } from "@react-navigation/native";
import CustomLabel from "../../../components/CustomLabel/CustomLabel";
import CustomButton from "../../../components/CustomButton";
import CustomDropDownWithIcons from "../../../components/CustomDropDownWithIcons";
import CustomCalendar from "../../../components/CustomCalendar/CustomCalendar";
import CustomInput from "../../../components/CustomInput";
import MonitorsScreen from "../HRAdminReports/Monitors/MonitorsScreen";
import { Checkbox } from "react-native-paper";
import { showMessage } from "react-native-flash-message";
import { useAccountContext } from "../../../hooks/useAccountContext";
import { useTranslation } from "react-i18next";
import { useReports } from "../../../hooks/useReports";
import RoleGuard from "../../../components/RoleGuard";
import useRole from "../../../hooks/userRole";
import { TASKS, TASK_OPTIONS } from "../../../constants/Tasks";
//#endregion

const HRAdminPageReports = () => {
  //#region Const Definitions and UseRef and UseState
  const { t } = useTranslation();
  const { getTaskMenuOptions } = useRole();
  // * Rerort Group DropDown State
  const [repGrpOptions, setRepGrpOptions] = useState([]);
  const [repOptions, setRepOptions] = useState([]);
  const [selectedRepGrpCode, setSelectedRepGrpCode] = useState(undefined);
  const [selectRepExportType, setSelectRepExportType] = useState("");
  const [selectedRepCode, setSelectedRepCode] = useState(undefined);
  const [repParamsFields, setRepParamFields] = useState(undefined);
  const [ssrsUrls, setSsrsUrls] = useState([])
  const [ssrsData, setSSRSData] = useState(null)
  const [spParams, setSpParams] = useState({});
  const tempSpParamsRef = useRef({ ...spParams })
  const prevSpParams = useRef(spParams);
  const { repRepUserRoles, repGrpUserRoles, isLoading } = useAccountContext();

  const { getReportParams, getReportParamsFiltered, getSSRSReportLink, getSSRSEmbeded, isLoading: reportsLoading } = useReports();
  const { colors } = useTheme();
  const styles = makeStyles(colors);
  //#endregion

  //#region UseEffect

  useEffect(() => {
    // console.log(repGrpUserRoles)
    // console.log(repRepUserRoles);
    let tempGrpOptions = [];
    let tempReps = [];
    repGrpUserRoles?.map((repGrpItr) => {
      tempGrpOptions.push(
        { label: repGrpItr.sTitle, value: repGrpItr.mnuOption })
    });
    setRepGrpOptions(tempGrpOptions);

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      try {
        localStorage.setItem("isRefresh", "true");
        localStorage.setItem("lastVisitedScreen", "HRAdminPageReports");
      } catch (error) {
        console.log(error.message);
      }
    };
    if (Platform.OS === "web") {
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, [repGrpUserRoles]);

  // * Select Report Group Filter Reports - If null show all reports loaded from UserRoles
  useEffect(() => {
    let tempReps = [];
    if (selectedRepGrpCode !== undefined) {
      let filterData = repRepUserRoles.filter(obj => obj.upperLevelMnuOpt === selectedRepGrpCode);
      filterData?.map((repItr) => {
        tempReps.push(
          { label: repItr.sTitle, value: repItr.mnuOption })
      });
      setRepOptions(tempReps)
    }
    else if (repRepUserRoles) {
      repRepUserRoles?.map((repItr) => {
        tempReps.push(
          { label: repItr.sTitle, value: repItr.mnuOption })
      });
      setRepOptions(tempReps);
    }

  }, [selectedRepGrpCode, repRepUserRoles])

  useEffect(() => {
    if (selectedRepCode !== undefined) {
      getReportParams(selectedRepCode).then((resp) => {
        setRepParamFields(resp);
        let tempSpParams = {}
        // * Intialize the SP Cntrl parametrs 
        resp?.map((itr) => {
          let temp = "cntrl" + itr.paramId
          tempSpParams[temp] = ''
        })
        setSpParams(tempSpParams)
      })
    }

  }, [selectedRepCode])

  useEffect(() => {
    prevSpParams.current = spParams;
  }, [spParams])
  //#endregion

  //#region Helpers
  //* if refreshed, get data from session storage,
  //* to show same page as before refresh
  const checkIfRefreshed = async () => {
    try {
      let isRefresh = localStorage.getItem("isRefresh");
      if (isRefresh === "true") {
        setSelectedRepGrpCode(localStorage.getItem("selectedRepGrpCode"));
      }
    } catch (error) {
      console.log(error);
    }
  };
  //#endregion

  //#region Listener 
  // * Setting this state variable is causing a re-render 
  const resetFilters = () => {
    setSpParams(tempSpParamsRef.current)
  }
  const displayReport = (format = "PDF") => {
    let errortxt = "";
    let hasError = false;
    //* Check if mandatory fields where selected 
    repParamsFields.map((rItr) => {
      if (rItr.validate) {
        if (tempSpParamsRef.current['cntrl' + rItr.paramId] === '') {
          errortxt += rItr.title.toString() + ", ";
          hasError = true;
        }
      }
    })

    if (hasError) {
      showMessage({
        message: t("common:mandatoryError") + errortxt,
        type: "error",
        duration: 3000,
      });
      return;
    }

    // * Get the SSRS Link
    getSSRSReportLink(tempSpParamsRef.current, selectedRepCode).then((resp) => {
      setSsrsUrls(prevSsrsUrl => [...prevSsrsUrl, resp]);
      //* Display The SSRS Link
      getSSRSEmbeded(resp, format).then((embRes) => {
        setSSRSData(embRes);
      }).catch((error) => console.log(error))
      // openLink(resp);
      setSpParams(tempSpParamsRef.current)

    }).catch((error) => {
      console.error(error)
    })


  }
  //#endregion 

  //#region Render Report DropDown
  // * Helper Function 
  const NodeItem = ({ node, selected, paramId, setSelected, level = 1, tempSpParamsRef }) => {
    const [showChildren, setShowChildren] = useState(false);


    const toggleNodeAndChildren = (node, isSelected, selectedState, setSelected, tempSpParamsRef, paramId) => {
      const key = 'cntrl' + paramId;

      // * Collect only Deepest Ids 
      const collectLeafIds = (node) => {
        if (!node.children || node.children.length === 0) {
          return [node.id]; // leaf node
        }

        // recursively collect leaf ids from children
        let leafIds = [];
        node.children.forEach(child => {
          leafIds = leafIds.concat(collectLeafIds(child));
        });
        return leafIds;
      };

      // Get all ids to toggle
      const allIds = collectLeafIds(node);

      // Update tempSpParamsRef accordingly
      let currentIds = tempSpParamsRef.current[key] ? tempSpParamsRef.current[key].split(',').map(s => s.trim()) : [];

      if (isSelected) {
        // Remove all IDs
        currentIds = currentIds.filter(id => !allIds.includes(id.replace(/'/g, '')));
      } else {
        // Add all IDs (avoid duplication)
        allIds.forEach(id => {
          if (!currentIds.includes(`'${id}'`)) {
            currentIds.push(`'${id}'`);
          }
        });
      }
      tempSpParamsRef.current[key] = currentIds.join(',');

      // Update selected state for all nodes
      setSelected(prevSelected => {
        const updated = { ...prevSelected };
        allIds.forEach(id => {
          updated[id] = !isSelected;
        });
        return updated;
      });
    };

    const onToggle = () => {
      const currentState = !!selected[node.id];
      toggleNodeAndChildren(node, currentState, selected, setSelected, tempSpParamsRef, paramId);
    };
    return (
      <View style={{ marginLeft: 30 * level, alignItems: 'flex-start', paddingVertical: 0 }}>
        <SafeAreaView style={styles.modalCheckBoxRow}>

          <CustomButton
            iconName={!showChildren ? 'chevron-forward-outline' : 'chevron-down-outline'}
            onPress={() => {
              node.children?.length > 0 ? setShowChildren(!showChildren) : () => { }
            }}
            text={''}
            show={node.children?.length > 0 ? 'MAINLEFT' : 'DISABLED'}
            type={node.children?.length > 0 ? 'MAINLEFT' : 'DISABLED'}
            textTop='0'
            sz={15} />
          <Checkbox
            status={!!selected[node.id] ? 'checked' : 'unchecked'}
            onPress={onToggle}
          />
          <CustomLabel value={node.name.toString()} type="CHECKBOXLABELREP" />
        </SafeAreaView>
        {
          node.children?.length > 0 && showChildren && (
            <View style={{ flexDirection: 'column', marginTop: 20, flexWrap: 'wrap' }}>
              {node.children.map(child => (
                <NodeItem
                  key={child.id}
                  node={child}
                  paramId={paramId}
                  selected={selected}
                  setSelected={setSelected}
                  level={level + 1}
                  tempSpParamsRef={tempSpParamsRef}
                />
              ))}
            </View>
          )
        }
      </View >
    );
  };



  const buildTree = (levels) => {
    const idMap = new Map();
    // Flatten all nodes and make id → node map
    levels.flat().forEach(item => {
      if (item.hasOwnProperty('active')) {
        if (!item.active) {
          return;
        }
      }
      idMap.set(item.id, { ...item, children: [] });
    });

    const roots = [];

    // 2nd pass: attach children to parents
    idMap.forEach(node => {
      if (node.parent && idMap.has(node.parent)) {
        idMap.get(node.parent).children.push(node);
      } else {
        // no parent means it's a root
        roots.push(node);
      }
    });

    return roots;
  }

  const CheckboxTree = ({ data, paramId, selectedLoad = {}, tempSpParamsRef }) => {
    const [selected, setSelected] = useState(selectedLoad);
    return (
      <SafeAreaView>
        {data.map(node => (
          node.name.toString() === 'From' || node.name.toString() === 'To' ? <CustomLabel value={node.name.toString()} type="CHECKBOXLABELREP" /> :
            <NodeItem key={node.id} node={node} paramId={paramId} selected={selected} setSelected={setSelected} tempSpParamsRef={tempSpParamsRef} />
        ))}
      </SafeAreaView>
    );
  };

  const CalendarTree = ({ data, paramId, selectedLoad = {}, tempSpParamsRef }) => {
    const [selectedData, setSelectedData] = useState({
      startDate: "" || "",
      endDate: "" || ""
    });

    const handleDateChange = (newDates) => {
      const key = 'cntrl' + paramId;
      setSelectedData(newDates);
      tempSpParamsRef.current[key] = newDates.startDate;

    };
    return (
      <SafeAreaView style={styles.calendarNoOverlay}>
        <CustomCalendar
          calendarType={"RangePicker"}
          setRange={handleDateChange}
          range={selectedData}
          allowSingleDate={true}
          startingYear={2000}
        />
      </SafeAreaView>
    )
  }

  // * Draw Function 
  const RenderReportFilters = React.memo(({ repParam, spParams, tempSpParamsRef }) => {
    const [sqlLoadedData, setSqlLoadedData] = useState([]);
    const [sqlLoadedDataFiltered, setSqlLoadedDataFiltered] = useState([]);
    const [dropDownSQLs, setDropDownSQLs] = useState({})
    const [showFilters, setShowFilters] = useState(false);
    const [loadedParams, setLoadedParams] = useState({});
    const [search, setSearch] = useState("");
    const [isLoading, seIsLoading] = useState(false);
    const prevIsShowFilters = useRef(showFilters);
    //#region UseEffects
    useEffect(() => {
      if (repParam === undefined)
        return;
      // * Finding all the SQL queries and keeping the same method of loading as old HR 
      let target = 'sSQL';
      let sqlObj = {}
      for (const key in repParam) {
        if (repParam.hasOwnProperty(key)) {
          // Check if the key includes the target string (case insensitive)
          if (key.toLowerCase().includes(target.toLowerCase())) {
            if (repParam[key] !== '')
              sqlObj[key] = repParam[key]
          }
        }
      }
      setDropDownSQLs(sqlObj)
    }, [repParam])

    //* Filter Deep Helper 
    function filterDeep(data, searchTerm) {
      const lowerSearch = searchTerm.toLowerCase();

      return data
        .map(item => {
          // Recursively filter children if exist
          let filteredChildren = [];
          if (item.children) {
            filteredChildren = filterDeep(item.children, searchTerm);
          }

          // Check if current item matches searchTerm
          const matchesItem =
            item.name.toLowerCase().includes(lowerSearch) ||
            (item.id && item.id.toLowerCase().includes(lowerSearch));

          // Include this item if it matches or any of its children matched
          if (matchesItem || filteredChildren.length > 0) {
            return {
              ...item,
              children: filteredChildren, // filtered children or empty array
            };
          }

          // Exclude this item if no match found
          return null;
        })
        .filter(item => item !== null);
    }

    // * For Filtering Functionality 
    useEffect(() => {
      if (search === '') {
        setSqlLoadedDataFiltered(sqlLoadedData);
      } else {
        const filtered = filterDeep(sqlLoadedDataFiltered, search)
        setSqlLoadedDataFiltered(filtered);
      }
    }, [search])

    useEffect(() => {
      tempSpParamsRef.current = { ...spParams }
      if (Object.keys(dropDownSQLs).length !== 0) {
        seIsLoading(true);
        getReportParamsFiltered(dropDownSQLs, spParams).then((resp) => {
          setSqlLoadedData(buildTree(resp))
          setSqlLoadedDataFiltered(buildTree(resp))
        }).catch((error) => {
          console.log(error)
        })
      }
      let result = {};
      let matches = [...spParams['cntrl' + repParam.paramId].matchAll(/['"]([^'"]+)['"]/g)].map(m => m[1]);
      matches.forEach(item => {
        if (item !== '')
          result[item] = true;
      });
      seIsLoading(false);
      setLoadedParams(result);
    }, [dropDownSQLs, spParams])

    if (isLoading) {
      return (
        <SafeAreaView
          style={styles.main}>
          <ActivityIndicator animating={true} size='large' color="#86BC25" />
        </SafeAreaView>
      )
    }
    return (
      <SafeAreaView>
        <SafeAreaView style={[styles.row]}>
          <CustomButton
            iconName={!showFilters ? 'chevron-forward-outline' : 'chevron-down-outline'}
            onPress={() => {
              setShowFilters(!showFilters)
            }}
            text={repParam.title.toString() + (repParam.validate ? "  *" : "")}
            show='REPORT'
            type='REPORT'
            textTop='0'
            sz={15} />
          {showFilters && <CustomInput
            placeholder="Type to search..."
            value={search}
            setValue={setSearch}
            type="REPORT"
          />}
        </SafeAreaView>
        {showFilters && (repParam.paramId === '23' || repParam.paramId === '24' ?
          <CalendarTree data={sqlLoadedDataFiltered} paramId={repParam.paramId} spParams={spParams} selectedLoad={loadedParams} tempSpParamsRef={tempSpParamsRef} /> :
          <CheckboxTree data={sqlLoadedDataFiltered} paramId={repParam.paramId} spParams={spParams} selectedLoad={loadedParams} tempSpParamsRef={tempSpParamsRef} />)}
      </SafeAreaView >

    )
  })

  // * This is for Embedded 
  const SnippetForReport = () => {
    return (
      ssrsData ?
        <iframe
          src={ssrsData}
          width="100%"
          height="70%"
          frameBorder="0"
        /> : <></>

    );
  }

  const openLink = async (url) => {
    try {
      const supported = await Linking.canOpenURL(url);
      if (supported) {
        await Linking.openURL(url);
      } else {
        console.log("Don't know how to open UR");
      }
    } catch (err) {
      console.error("An error occurred", err);
    }
  };
  //#endregion


  if (isLoading) {
    return (
      <SafeAreaView style={styles.main}>
        <CustomLabel value={t("common:loading")} type="ASSM" />
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.rowMain}>
      <SafeAreaView style={styles.main}>
        <View style={styles.mainSubTabs}>
          <View style={[styles.mainSubTabsDropdown, { zIndex: 2000 }]}>
            <CustomLabel value={t("common:repGrps")} type="REP" />
            <CustomDropDownWithIcons
              defValue={selectedRepGrpCode}
              options={repGrpOptions}
              setValue={setSelectedRepGrpCode}
              type="MYPROFILE"
              zIndex={2000}
            />
          </View>
          <View style={[styles.mainSubTabsDropdown, { zIndex: 1000 }]}>
            <CustomLabel value={t("common:reps")} type="REP" />
            <CustomDropDownWithIcons
              defValue={selectedRepCode}
              options={repOptions}
              setValue={setSelectedRepCode}
              type="MYPROFILE"
              zIndex={1000}
            />
          </View>
        </View>
        {repParamsFields !== undefined &&
          <SafeAreaView style={styles.rowFilter}>
            <CustomButton
              text={t('common:showrep')}
              onPress={() => displayReport()}
              iconName="newspaper-outline"
              disabled={reportsLoading}
              show="BUTTON_ADD"
              type="BUTTON_ADD"
              textTop="0"
              sz={20}
            />
            <CustomButton
              text={t('common:exportExcel')}
              onPress={() => displayReport('excel')}
              disabled={reportsLoading}
              iconName="newspaper-outline"
              show="BUTTON_ADD"
              type="BUTTON_ADD"
              textTop="0"
              sz={20}
            />
            {ssrsData !== null && <CustomButton
              onPress={() => setSSRSData(null)}
              iconName="close-outline"
              show="HOME_BELL"
              type="HOME_BELL"
              textTop="0"
              sz={30}
            />
            }
            {/* No Drop Down for now just export to Excel  */}
            {/* <CustomDropDownWithIcons
              defValue={selectRepExportType}
              options={[
                { label: 'Excel', value: 'Excel' },
                { label: 'Åland Islands', value: 'AX' },
                { label: 'Algeria', value: 'DZ' },
                { label: 'American Samoa', value: 'AS' },
                { label: 'Andorra', value: 'AD' },
              ]}
              setValue={setSelectRepExportType}
              type="MYPROFILE"
              zIndex={2000}
            /> */}
          </SafeAreaView>}
        <ScrollView style={[repParamsFields !== undefined ? styles.repfilters : styles.repfiltersHide]}>
          {repParamsFields !== undefined &&
            <SafeAreaView style={styles.rowFilter}>
              <CustomLabel value={t("common:filters")} type="FILTER" />
              <CustomButton
                text={t('common:refFilter')}
                onPress={() => resetFilters()}
                iconName="filter-outline"
                show="SHOW_REPORT"
                type="SHOW_REPORT"
                textTop="0"
                tooltipText={t('common:refFilterTool')}
                sz={15}
              />
            </SafeAreaView>
          }
          {repParamsFields?.map((rItr, index) => {
            return (
              <RenderReportFilters key={index} index={index} repParam={rItr} spParams={spParams} tempSpParamsRef={tempSpParamsRef} />)
          })}
        </ScrollView>
      </SafeAreaView>
      <SafeAreaView style={styles.mainDetails}>
        <RoleGuard parentTask={TASKS.MONITORS} task={TASK_OPTIONS.ALERTS} table='hr' requireCRUD>
          <MonitorsScreen />
        </RoleGuard>
        {reportsLoading &&
          <SafeAreaView
            style={styles.main}><ActivityIndicator animating={true} size='large' color="#86BC25" />
          </SafeAreaView>}
        <SnippetForReport />
      </SafeAreaView>
    </SafeAreaView >
  );
};

const makeStyles = (colors) =>
  StyleSheet.create({
    main: {
      flex: 1,
      marginTop: 20,
    },
    mainDetails: {
      flex: 2,
      margin: 20,
    },
    repfiltersHide: {
      width: '70%',
      backgroundColor: 'transparent',
    },
    repfilters: {
      width: '70%',
      backgroundColor: (Platform.OS === 'web' ? colors.background_card : colors.background),
      margin: 15,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.3,
      shadowRadius: 4,
      backgroundColor: '#fff',
      borderRadius: 8,
    },
    subMain: {
      flex: 1,
      flexDirection: 'row',
      marginTop: "1%",
    },
    row: {
      width: '25%',
      borderBlockColor: 'black',
      flexDirection: 'row',
      marginHorizontal: 10,
      marginVertical: 5,
    },
    rowFilter: {
      flexDirection: 'row',
    },
    rowMain: {
      flex: 1,
      flexDirection: 'row',
    },
    mainSubTabs: {
      width: "100%",
      zIndex: 2000,
      alignSelf: "flex-start",
      marginBottom: "1%",

    },
    mainSubTabsDropdown: {
      width: "100%",
      maxWidth: 400,
      justifyContent: "center",
      marginHorizontal: 10,
    },
    modalCheckBoxRow: {
      flex: 1,
      flexDirection: "row",
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    submain: {
      flex: 1,
      marginHorizontal: Platform.OS === "web" ? 10 : 5,
      backgroundColor:
        Platform.OS === "web" ? colors.background_card : colors.background,
      borderRadius: 35,
      elevation: Platform.OS === "web" ? 3 : 0,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.1,
      shadowRadius: Platform.OS === "web" ? 5 : 0,
    },
    invCheck: {
      backgroundColor: 'black',
      flex: 1,
      padding: 10,
      marginLeft: 20,
      alignSelf: 'flex-start'
    },
    calendarNoOverlay: {
      flex: 1,
      minHeight: 295,
      justifyContent: "center",
      alignSelf: "center",
      alignItems: "center",
    },
  });

export default HRAdminPageReports;
